import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/category.vue'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'Index',
    //     component: Index
    // },
    {
        path: '/',
        name: 'Index',
        meta: {
          issearch: true,
      },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/category.vue')
        component: Index
    },
    {
        path: '/details',
        name: 'Details',
        meta: {
          detailsHide: true,
      },
        component: () => import('../views/details.vue')
    },
    {
        path: '/carts',
        name: 'Carts',
        meta: {
            navHide: true,
        },
        component: () => import('../views/carts.vue'),
    },
    {
        path: '/pay',
        name: 'Pay',
        meta: {
            navHide: true,
        },
        component: () => import('../views/pay.vue')
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('../views/address.vue')
    },
    {
        path: '/addaddress',
        name: 'Addaddress',
        component: () => import('../views/addaddress.vue')
    },
    {
        path: '/editaddress',
        name: 'Editaddress',
        component: () => import('../views/editaddress.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/login.vue')
    },
    {
        path: '/personal',
        name: 'Personal',
        component: () => import('../views/personal.vue')
    },
    {
        path: '/myprofile',
        name: 'Myprofile',
        component: () => import('../views/myprofile.vue')
    },
    {
        path: '/changepasd',
        name: 'Changepasd',
        component: () => import('../views/changepasd.vue')
    },
    {
        path: '/wishlist',
        name: 'Wishlist',
        component: () => import('../views/wishlist.vue')
    },
    {
        path: '/voucher',
        name: 'Voucher',
        component: () => import('../views/voucher.vue')
    },
    {
        path: '/orders',
        name: 'Orders',
        component: () => import('../views/orders.vue')
    },
    {
        path: '/logistics',
        name: 'Logistics',
        component: () => import('../views/logistics.vue')
    },
    {
        path: '/orderdetail',
        name: 'Orderdetail',
        component: () => import('../views/orderdetail.vue')
    },
    {
        path: '/selectaddress',
        name: 'Selectaddress',
        component: () => import('../views/selectaddress.vue')
    },
    {
        path: '/paysuccess',
        name: 'Paysuccess',
        meta: {
            navHide: true,
        },
        component: () => import('../views/paysuccess.vue')
    },
    {
        path: '/reviews',
        name: 'Reviews',
        component: () => import('../views/reviews.vue')
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('../views/help.vue')
    },
    {
        path: '/agreement',
        name: 'Agreement',
        component: () => import('../views/agreement.vue')
    },
    {
        path: '/password',
        name: 'Password',
        component: () => import('../views/password.vue')
    },
    {
        path: '/newpassword',
        name: 'Newpassword',
        component: () => import('../views/newpassword.vue')
    },
    {
        path: '/testtemp',
        name: 'Testtemp',
        component: () => import('../views/testtemp.vue')
    },
    // {
    //     path: '/searchorder',
    //     name: 'Searchorder',
    //     component: () => import('../views/searchorder.vue')
    // },
    {
        path: '/payfail',
        name: 'Payfail',
        meta: {
            navHide: true,
        },
        component: () => import('../views/payfail.vue')
    },
    {
        path: '/pay_re',
        name: 'Pay_re',
        meta: {
            navHide: true,
        },
        component: () => import('../views/pay_re.vue')
    },
    {
        path: '/search',
        name: 'Search',
        meta: {
            navHide: true,
        },
        component: () => import('../views/search.vue')
    },
]

const router = new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0) // 页面置顶
    next() // 继续导航
})
export default router
